/**
 * Tiny typed event bus. Components subscribe independently; the world engine,
 * behavioral engine and overlays communicate through it without imports of
 * each other.
 */

export type BusEvent =
  | { type: 'ZONE_ENTERED'; zone: import('./types').ZoneId }
  | { type: 'ZONE_EXITED'; zone: import('./types').ZoneId }
  | { type: 'PROJECT_OPENED'; slug: string }
  | { type: 'RESEARCH_OPENED'; slug: string }
  | { type: 'AGENT_SELECTED'; id: string }
  | { type: 'NODE_FOCUSED'; id: string }
  | { type: 'USER_IDLE'; ms: number }
  | { type: 'USER_ACTIVE' }
  | { type: 'INTENT_CHANGED'; intent: import('./types').IntentId }
  | { type: 'CORE_ACTIVITY_CHANGED'; status: import('./types').LabStatus }
  | { type: 'AI_ACTION_REQUESTED'; action: import('../ai/actions').UIAction }
  | { type: 'CAMERA_TRANSITION_STARTED'; zone: import('./types').ZoneId }
  | { type: 'CAMERA_TRANSITION_COMPLETED'; zone: import('./types').ZoneId };

type Handler = (e: BusEvent) => void;

const handlers = new Set<Handler>();

export function onLabEvent(handler: Handler): () => void {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function emitLabEvent(e: BusEvent): void {
  for (const h of handlers) {
    try {
      h(e);
    } catch {
      // one broken listener must never break the bus
    }
  }
}
